module.exports = __webpack_public_path__ + "static/img/weixinqrcode.cef2080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weixinqrcode.png
// module id = Wvv1
// module chunks = 13